<script setup>
import { computed, ref } from 'vue'
import DxForm from 'devextreme-vue/form'

import ChipStatus from './ChipStatus.vue'

import { useGarageStore } from '@/stores/garage.store'

const garageStore = useGarageStore()

const props = defineProps({
  mainTitle: {
    type: String,
    default: null
  },
  formData: {
    type: Object,
    default: null
  },
  formItems: {
    type: Array,
    required: true
  },
  additionalSections: {
    type: Array,
    default: () => []
  },
  timeKey: {
    type: String,
    default: null
  }
})

const formRef = ref(null)

defineExpose({
  formRef
})

const computedItems = computed(() => {
  const baseItems = props.formItems || []

  const additional = (props.additionalSections || []).flatMap(section => {
    return [
      {
        itemType: 'simple',
        template: `section_${section.title}`
      },
      ...section.sectionFormItems
    ]
  })

  return [...baseItems, ...additional]
})

</script>
<template>
  <div>
    <p
      v-if="props.mainTitle"
      class="title-section"
    >
      {{ props.mainTitle }}
    </p>
    <dx-form
      :key="`${props.formData?.id}-${props.timeKey}`"
      ref="formRef"
      :form-data="props.formData"
      :items="computedItems"
      :read-only="true"
      label-location="left"
      col-count="1"
    >
      <template #progressStatusTemplate="{ data }">
        <ChipStatus :data="garageStore.getLocalizedDocumentProgressStatuses().find(x => x.id === data.editorOptions.value)" />
      </template>
      <template
        v-for="(_, name) in $slots"
        #[name]="slotProps"
      >
        <slot
          :name="name"
          v-bind="slotProps ?? {}"
        />
      </template>
      <template
        v-for="section in props.additionalSections"
        :key="section.title"
        #[`section_${section.title}`]
      >
        <p class="title-section">
          {{ section.title }}
        </p>
      </template>
    </dx-form>
  </div>
</template>
<style scoped lang="scss">
.title-section {
  margin-bottom: 0px;
  font-weight: bold;
}
</style>
